import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Shield, Trophy, Play, Store, User, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const MobileBottomNav = () => {
    const { user } = useAuth();
    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const isAdmin = user?.role === 'admin';

    let navItems = [];

    if (!user) {
        // Guest user navigation
        navItems = [
            {
                path: '/league',
                icon: Trophy,
                label: t('nav.league', 'Lig'),
                isActive: location.pathname === '/league'
            },
            {
                path: '/feed',
                icon: Play,
                label: t('nav.social', 'Sosyal'),
                isActive: location.pathname === '/feed'
            },
            {
                path: '/market',
                icon: Store,
                label: t('nav.market', 'Market'),
                isActive: location.pathname === '/market'
            },
            {
                path: '/login',
                icon: LogIn,
                label: 'Giriş Yap',
                isActive: location.pathname === '/login'
            }
        ];
    } else {
        // Authenticated user navigation
        navItems = [
            {
                path: isAdmin ? '/admin' : '/mobile-menu',
                icon: Shield,
                label: isAdmin ? t('nav.admin', 'Admin') : t('nav.team', 'Takım'),
                isActive: isAdmin
                    ? location.pathname.startsWith('/admin')
                    : (location.pathname === '/mobile-menu' || location.pathname.includes('/teams/')
                        || location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/playbook')
                        || location.pathname.startsWith('/roster') || location.pathname.startsWith('/notes')
                        || location.pathname.startsWith('/training') || location.pathname.startsWith('/analytics')
                    )
            },
            {
                path: '/league',
                icon: Trophy,
                label: t('nav.league', 'Lig'),
                isActive: location.pathname === '/league'
            },
            {
                path: '/feed',
                icon: Play,
                label: t('nav.social', 'Sosyal'),
                isActive: location.pathname === '/feed'
            },
            {
                path: '/market',
                icon: Store,
                label: t('nav.market', 'Market'),
                isActive: location.pathname === '/market'
            },
            {
                path: `/profile/${user?.username || 'me'}`,
                icon: User,
                label: t('nav.profile', 'Profilim'),
                isActive: location.pathname.startsWith('/profile') || location.pathname === '/settings' || location.pathname === '/stats'
            }
        ];
    }

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-[#000] border-t border-gray-800 z-50 px-2 pb-[env(safe-area-inset-bottom)]">
            <div className="flex justify-between items-center h-20 max-w-md mx-auto">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = item.isActive;
                    const isProfile = item.path.startsWith('/profile');
                    const isTeam = item.path === '/mobile-menu' || item.path.includes('/teams/');
                    const userAvatar = user?.profile?.avatar_url || user?.avatar_url;
                    const teamLogo = user?.team_logo_url;
                    const showImage = (isProfile && userAvatar) || (isTeam && teamLogo);
                    const imageSrc = isProfile ? userAvatar : teamLogo;

                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-colors ${isActive ? 'text-snapp-green' : 'text-gray-500 hover:text-gray-300'
                                }`}
                        >
                            {showImage ? (
                                <div className={`relative flex items-center justify-center`}>
                                    <img
                                        src={imageSrc}
                                        alt={item.label}
                                        className={`w-7 h-7 rounded-full object-cover border-[1.5px] transition-all ${isActive ? 'border-snapp-green scale-110' : 'border-gray-500'
                                            }`}
                                    />
                                    {isActive && (
                                        <div className="absolute -bottom-1 w-1 h-1 bg-snapp-green rounded-full shadow-[0_0_8px_rgba(34,197,94,0.6)]" />
                                    )}
                                </div>
                            ) : (
                                <Icon className={`w-7 h-7 ${isActive ? 'fill-snapp-green/20' : ''}`} />
                            )}
                            <span className="text-xs font-medium tracking-wide">
                                {item.label}
                            </span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default MobileBottomNav;
